// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_MiX","cls2":"common-cls2_6-W common-cls1_MiX"};